import "../assets/scss/components/_website-banner.scss";
import type { WebsiteBannerProps } from "../types/components/WebsiteBannerProps";

export const WebsiteBanner = ({ link, text, buttonText }: WebsiteBannerProps) => {
	return (
		<a className="website-banner" href={link}>
			<span>{text}</span>

			<div className="btn-container">
				<div className="btn">{buttonText}</div>
			</div>
		</a>
	);
};
